// #/services/workflows/getWorkflow.ts

import { join as pathJoin } from 'path';

import { logger } from '#/logger';
import readJsonFile from '#/services/s3/actions/json/readJsonFile';
import { IWorkflow } from '#/types/workspace';

import { PATH_USERS } from '../s3/filepaths';

export async function getWorkflow(args: {
  ownerAddress: string;
  workflowUuid: string;
}): Promise<IWorkflow | null> {
  try {
    const { ownerAddress, workflowUuid } = args;
    logger.info('getWorkflow(', JSON.stringify(args), ')');

    const userHome = pathJoin(PATH_USERS, ownerAddress);
    const userWorkflowsFolderKey = pathJoin(userHome, 'workflows/');
    const workflowKey = pathJoin(
      userWorkflowsFolderKey,
      `${workflowUuid}.json`,
    );

    return await readJsonFile({
      s3ObjectKey: workflowKey,
    });
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error getting workflow: ${error.message}`);
  }
}
export default getWorkflow;
